module.exports = __webpack_public_path__ + "static/baked_cookies_01-c103b1a6eacee1a6004eebf44b9d08d7.jpg";